
const ua = navigator.userAgent
const isAndroidApp = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1

import { Options, Vue } from 'vue-class-component'
import { mapGetters } from 'vuex'
import { getProfileContent } from '@/api/aio'

import { isNewBridgeView } from '@/assets/js/utils.js'
import { getClientCommonMessage, getDeviceInfo, doJump } from '@/utils/nativeFn'

@Options({
  components: {},
  computed: {
    ...mapGetters(['collectionInfo'])
  }
})
export default class InfoCollectionDetail extends Vue {
  $store
  $route
  purpose: any = {} // 目的
  scenarios: any = {} // 收集/使用场景
  collection_key: String = ''
  fatherKey: String = ''
  isLoading: boolean = true
  queryDone: boolean = false

  created() {
    // this.updatedData();
    // 获取端内手机版本数据
    // this.formatDeviceProperties();
  }
  mounted() {
    // this.getProfileContentFn()
    if (isNewBridgeView()) {
      this.initNewData()
    } else {
      this.getNativeData()
      window['$eventBus'].addListener('receiveAndroidMsg', this.receiveAndroidMsg)
    }
  }
  updatedData() {}
  unmounted() {
    if (!isNewBridgeView()) {
      window['$eventBus'].removeListener('receiveAndroidMsg', this.receiveAndroidMsg)
    }
  }
  // 新的dsbridge初始化
  initNewData() {
    // 监听题目切换
    this.getNewNativeData()
    let num = 0
    let timer = setInterval(() => {
      if (this.queryDone) {
        clearInterval(timer)
        return
      } else {
        this.getNewNativeData()
        num++
        if (num === 10) {
          clearInterval(timer)
          this.getProfileContentFn()
        }
      }
    }, 500)
  }
  // 新端获取数据
  getNewNativeData() {
    if (this.queryDone) {
      return
    }
    getClientCommonMessage({}, (res) => {
      console.log(res, 'h5调用端上getClientCommonMessage')
      res.token && localStorage.setItem('tal_token', res.token)
      res.user_id && localStorage.setItem('TAL_UID_TMP', res.user_id)
      res.services_version = localStorage.setItem('service_version', res.service_version)
      this.queryDone = true
      // 获取到端上数据之后开始调用接口
      this.getProfileContentFn()
    })
  }
  formatDeviceProperties() {
    // 设备信息key值判断
    if (this.fatherKey === 'deviceProperties') {
      if (isNewBridgeView()) {
        getDeviceInfo((res) => {
          this.getDeviceInfoFn(res)
        })
        return
      }
      window['$mobileNativeSDK'].getDeviceInfo((res) => {
        if (!isAndroidApp) {
          this.getDeviceInfoFn(res)
        }
      })
    }
  }
  receiveAndroidMsg(res) {
    // console.log(res);
    let androidResult: any = JSON.parse(res)
    if (androidResult.event === 'deviceInfo') {
      // 监听获取数据返回
      this.getDeviceInfoFn(androidResult.data)
    }
    if (androidResult.event == 'getData') {
      // 监听获取数据返回
      this.detailNativeData(androidResult.dataJson)
    }
  }
  getDeviceInfoFn(res) {
    // console.log(`个人信息清单=>`, res);
    this.scenarios.value.forEach((e) => {
      const key = e.key
      if (key === 'describe') return
      e.value = res[key] || '未收集'
    })
  }

  // 从端上获取数据
  getNativeData() {
    window['$mobileNativeSDK'].getData((res) => {
      if (!isAndroidApp) {
        this.detailNativeData(res)
      }
    })
  }
  // // 安卓监听消息
  // receiveAndroidMsg(res) {
  //   let androidResult: any = JSON.parse(res);
  //   if (androidResult.event == "getData") {
  //     // 监听获取数据返回
  //     this.detailNativeData(androidResult.dataJson);
  //   }
  // }
  // 处理端上数据
  detailNativeData(res) {
    if (localStorage.getItem('tal_token') !== res.token) {
      localStorage.setItem('tal_token', res.token)
    }
    if (res.service_version) {
      localStorage.setItem('service_version', res.service_version)
    }
    // 获取到端上数据之后开始调用接口
    this.getProfileContentFn()
  }
  async getProfileContentFn() {
    // TODO
    // this.isLoading = false
    // this.infoCollection = ConfigCollection.info_collection
    // this.$store.commit('SET_COLLECTIONINFO', ConfigCollection);
    // console.log(ConfigCollection, 'data')
    // console.log(this.$route.query, "route");
    document.title = this.$route.query.lable as any
    const collection_key = this.$route.query.collection_key as any
    this.collection_key = collection_key
    // 父级菜单key
    const fatherKey = this.$route.query.fatherKey as any
    this.fatherKey = fatherKey
    this.isLoading = true
    if (this.fatherKey && collection_key) {
      await getProfileContent({
        collection_key: fatherKey,
        content_key: collection_key
      })
        .then((res) => {
          this.isLoading = false
          if (res.data.code != '0') {
            this.$dialog.alert({
              message: res.data.message,
              confirmButtonText: '我知道了'
            })
            return
          }
          // console.log(res, "result------1");

          const info = res.data.data
          this.purpose = info.purpose
          this.scenarios = info.scenarios
          this.formatDeviceProperties()
          // this.list = info.profile_item;
          // this.isLoading = false;
          // this.$store.commit('SET_COLLECTIONINFO', info);
        })
        .catch(() => {
          this.isLoading = false
        })
    }
  }
  jumpH5(info) {
    let { key } = info
    let hostname
    let baseUrl
    // console.log(info,this.collection_key,'info')
    if (process.env.VUE_APP_PREPATH !== 'production') {
      hostname = window.location.hostname
      baseUrl = `https://${hostname}/web_ta_store/#`
    } else {
      baseUrl = `https://ibook.xesvip.cn/store/#`
      //todo:补充商城线上地址
    }

    if (
      key === 'collectContent' &&
      (this.collection_key === 'user_orders_additional' ||
        this.collection_key === 'user_orders_records')
    ) {
      // 跳转h5
      let url = ''
      if (this.collection_key === 'user_orders_records') {
        url = `${baseUrl}/orderList?hideNavBar=1&sourceLocation=aio_book`
        // console.log("订单",url,'https://dev-bookh5.xueersibook.com/web_ta_store/#/orderList?');
      } else {
        url = `${baseUrl}/cart?hideNavBar=1&sourceLocation=aio_book`
        // console.log("购物车",url,'https://dev-bookh5.xueersibook.com/web_ta_store/#/cart');
      }
      // console.log(url,'urlurlurlurlurl')
      let path = `10001?parameters=${encodeURIComponent(
        JSON.stringify({
          url
        })
      )}`
      doJump(path, () => {
        // console.log("跳转成功", path);
      })
    } else if (key === 'collectContent' && this.collection_key === 'user_address') {
      // 跳转 flutter
      // console.log(222);
      let path = `10004`
      doJump(path, () => {
        // console.log("跳转成功", path);
      })
    }
  }
}
